<template>
    <div v-if="!search">
        <div class="row">
            <div class="col col-12 col-md-9">
                <small v-if="value">
                    Utilize o recurso de arrastar e soltar para alterar a ordenação dos registros. <br>
                    Os registros mais restritivos devem ser sempre os primeiros.
                </small>
            </div>
            <div class="col col-12 col-md-3">
                <div class="text-right" v-if="!search">
                    <slot name="opcoes" v-if="!value"></slot>
                    <button type="button" class="btn btn-sm mb-3    " 
                        :disabled="disabled ? true : false"
                        :class="value ? 'btn-primary' : 'btn-outline-primary'"
                        @click="toggle()">
                        <i class="fas fa-sort-amount-down-alt mr-2"></i>
                        {{ value ? 'Encerrar Ordenação' : 'Editar Ordenação' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['search', 'value', 'disabled'],

    methods: { 
        toggle() { 
            this.$emit('input', !this.value);
        }
    }
}
</script>